import { theSameArray as t } from "../../utils/compare.js";
import { useBindProp as r } from "../props.js";
import { makeOptionsSetter as o } from "../../utils/options.js";
import { StrokeStyles as e } from "../../utils/types.js";
import s from "../common/overlay.js";
var i = o("strokeColor"),
    a = o("strokeOpacity"),
    m = o("strokeWeight"),
    p = o("strokeStyle"),
    l = o("strokeDasharray");

function k(o, k) {
  s(o, k), r(o, {
    setter: i
  }, k.strokeColor), r(o, {
    setter: a
  }, k.strokeOpacity), r(o, {
    setter: m
  }, k.strokeWeight), r(o, {
    setter: p,
    validate: function validate(t) {
      return e.includes(t);
    }
  }, k.strokeStyle), r(o, {
    setter: l,
    equals: t
  }, k.strokeDasharray);
}

export default k;